// extracted by mini-css-extract-plugin
export default {"highlight":"DispatchOverviewTab_highlight__qfwrB","region":"DispatchOverviewTab_region__6gXTr"};